import {notificationType} from "../../../utils/notification.utils";

export const NotificationType = ({type}) => {
    return notificationType(type);
}